import { render, staticRenderFns } from "./BuildingShowLotTab.vue?vue&type=template&id=6b42fc9a"
import script from "./BuildingShowLotTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowLotTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports